import { BetSlipItem, Campaign } from '@mobi/betslip/types'

export const updateItemsWithCampaign = (
  stateItems: BetSlipItem[],
  itemId: BetSlipItem['id'],
  incomingCampaign: Campaign | undefined,
  bonusBetInvestmentType?: 'Win' | 'Place'
): BetSlipItem[] => {
  return stateItems.map(item => {
    if (item.id !== itemId) {
      if (
        incomingCampaign?.rewardType === 'BonusBetReward' &&
        item.campaign?.id === incomingCampaign.id
      ) {
        return {
          ...item,
          campaign: undefined,
          investment: {
            ...item.investment,
            win: { ...item.investment.win, value: 0, isBonusBet: false },
            place: { ...item.investment.place, value: 0, isBonusBet: false },
            bonusBet: undefined,
          },
        }
      }
      return item
    }

    // reset special offer
    const updatedItem = { ...item, selectedSuperPickOffer: null }

    let updatedInvestment = { ...updatedItem.investment }
    let updatedCampaign = incomingCampaign || undefined

    if (updatedItem.campaign?.id === incomingCampaign?.id) {
      updatedCampaign = undefined
      updatedInvestment = {
        ...updatedInvestment,
        win: { ...updatedInvestment.win, value: 0, isBonusBet: false, isBonusCash: false },
        place: { ...updatedInvestment.place, value: 0, isBonusBet: false, isBonusCash: false },
        bonusBet: undefined,
      }
    } else {
      if (incomingCampaign) {
        const isBonusBet = incomingCampaign.rewardType === 'BonusBetReward'
        const isBonusCash = incomingCampaign.rewardType === 'BonusCashReward'

        if (
          updatedItem.campaign?.rewardType &&
          updatedItem.campaign.rewardType !== incomingCampaign.rewardType
        ) {
          updatedInvestment = {
            ...updatedInvestment,
            win: { ...updatedInvestment.win, value: 0, isBonusBet: false, isBonusCash: false },
            place: { ...updatedInvestment.place, value: 0, isBonusBet: false, isBonusCash: false },
            bonusBet: undefined,
          }
        }

        updatedInvestment = {
          ...updatedInvestment,
          win: {
            ...updatedInvestment.win,
            value:
              isBonusBet && bonusBetInvestmentType === 'Win' ? incomingCampaign.remainingAmount : 0,
            isBonusBet: isBonusBet,
            isBonusCash,
          },
          place: {
            ...updatedInvestment.place,
            value:
              isBonusBet && bonusBetInvestmentType === 'Place'
                ? incomingCampaign.remainingAmount
                : 0,
            isBonusBet: isBonusBet,
            isBonusCash,
          },
          bonusBet: {
            campaignId: incomingCampaign.id,
            value: isBonusBet ? incomingCampaign.remainingAmount : 0,
          },
        }
        updatedCampaign = incomingCampaign
      }
    }
    return {
      ...updatedItem,
      campaign: updatedCampaign,
      investment: updatedInvestment,
    }
  })
}
